module.exports = __webpack_public_path__ + "media/icons/portfolio-bd3d68b9.png";